import {
	AppBar,
	Button,
	ButtonGroup,
	Card,
	Dialog,
	DialogActions,
	Divider,
	MenuItem,
	Slide,
	TextField,
	Toolbar,
	Typography,
	IconButton,
	makeStyles,
} from "@material-ui/core";
import Decoded from "jwt-decode";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import Dropzone from "../../components/molecules/Dropzone";
import { ReactHookFormSelect } from "../../utils";
import CloseIcon from "@material-ui/icons/Close";
import "./style.css";

const Transition = React.forwardRef(function Transition(props, ref) {
	return <Slide direction="up" ref={ref} {...props} />;
});

const useStyles = makeStyles((theme) => ({
	card: {
		paddingLeft: theme.spacing(6),
		paddingRight: theme.spacing(6),
		[theme.breakpoints.down("xs")]: {
			paddingLeft: theme.spacing(3),
			paddingRight: theme.spacing(3),
		},
	},
	textField: {
		width: "100%",
	},
}));

export default function FormOnTask(props) {
	const decode = Decoded(localStorage.getItem("token"));
	const [isLoading, setIsLoading] = useState(false);
	const classes = useStyles();
	const {
		open,
		handleClose,
		fetchAPI,
		singleOption,
		SingleHandleOptions,
		MultiHandleOptionsTask,
		stateOption,
		setStateOption,
		sendMessages,
	} = props;

	const [state, setState] = useState(1);

	const [addChange, setAddChange] = useState({
		idlayanan: "",
		idpriority: 1,
		idkategori: "",
		idgroup: "",
		iduser: "",
		deskripsi: "",
		title: "",
		deadline: "",
		location: "",
	});

	const [selectFile, setSelectFile] = useState({ file: [] });
	const { idlayanan, idpriority, idkategori, idgroup, iduser } = addChange;

	const { handleSubmit, errors, control, register, clearErrors } = useForm();

	const reset = () => {
		setAddChange({
			...addChange,
			idlayanan: "",
			idpriority: 1,
			idkategori: "",
			idgroup: "",
			iduser: "",
			deskripsi: "",
			title: "",
			deadline: "",
			location: "",
		});
		setSelectFile({ file: [] });
		setStateOption({ ...stateOption, optionSLA: "" });
		clearErrors();
	};

	const handleResetGroup = (type) => {
		if (type === "idgroup") {
			setState(1);
			setAddChange({
				...addChange,
				iduser: "",
			});
		} else if (type === "iduser") {
			setState(2);
			setAddChange({
				...addChange,
				idgroup: "",
			});
		}
	};

	const onSubmit = async (data) => {
		setIsLoading(true);
		const formData = new FormData();
		const dataFetch = {
			...addChange,
			title: data.title,
			deskripsi: data.deskripsi,
			deadline: stateOption.optionSLA,
			location: data.location,
		};

		Object.values(selectFile).forEach((file, index) => {
			formData.append("title", dataFetch.title);
			formData.append("location", dataFetch.location);
			formData.append("deskripsi", dataFetch.deskripsi);
			formData.append("deadline", dataFetch.deadline);
			formData.append("idlayanan", dataFetch.idlayanan);
			formData.append("idpriority", dataFetch.idpriority);
			formData.append("idkategori", dataFetch.idkategori);
			formData.append("idgroup", dataFetch.idgroup);
			formData.append("iduser", dataFetch.iduser);
			if (file) {
				formData.append("images", file);
			} else {
				formData.append("images", []);
			}
			return selectFile;
		});

		let result = await fetchAPI("addForm", formData);
		if (result.status === "success") {
			sendMessages("issue", {
				idgroup: addChange.idgroup,
				iduser: addChange.iduser,
				idticket: result.idticket,
				title: dataFetch.title,
				location: dataFetch.location,
				deskripsi: dataFetch.deskripsi,
			});
			reset();
			handleClose();
		}
		setIsLoading(false);
		return result;
	};

	useEffect(() => {
		MultiHandleOptionsTask({
			params: {
				id: decode.id,
				idlayanan,
				idkategori,
				idpriority,
			},
		});
		SingleHandleOptions({
			path: "priority",
		});
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [idlayanan, idkategori]);

	// const theme = useTheme();
	// const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));

	return (
		<div>
			<Dialog
				// fullScreen={fullScreen}
				maxWidth="md"
				open={open}
				onClose={() => {
					setState(1);
					handleClose();
					reset();
				}}
				TransitionComponent={Transition}
			>
				<AppBar style={{ position: "sticky" }} color="secondary">
					<Toolbar>
						<IconButton
							edge="start"
							color="inherit"
							onClick={handleClose}
							aria-label="close"
						>
							<CloseIcon />
						</IconButton>
						<Typography variant="h6" component="div">
							OPEN ISSUE
						</Typography>
					</Toolbar>
				</AppBar>
				<Divider />

				<form onSubmit={handleSubmit(onSubmit)}>
					<Card className={classes.card}>
						<div className="card-like-bar">
							<div className="card-text">Priority</div>
							<ReactHookFormSelect
								id="idpriority"
								register={register}
								name="idpriority"
								label="Priority"
								control={control}
								error={errors.idpriority}
								value={idpriority}
								style={{ minWidth: "200px" }}
								// handleOption={handleOption}
								// handleChange={handleChange}
								setState={setAddChange}
								state={addChange}
								variant="outlined"
								margin="normal"
								fullWidth
								required
							>
								<MenuItem value="none" disabled selected>
									--Pilih Layanan--
								</MenuItem>
								{singleOption &&
									singleOption.map((item, i) => (
										<MenuItem key={i} value={item.id}>
											{item.nama}
										</MenuItem>
									))}
							</ReactHookFormSelect>
						</div>
						<div className="card-like-bar">
							<div className="card-text">Service</div>
							<ReactHookFormSelect
								id="idlayanan"
								register={register}
								name="idlayanan"
								label="Service"
								control={control}
								error={errors.idlayanan}
								value={idlayanan}
								style={{ minWidth: "200px" }}
								// handleOption={handleOption}
								// handleChange={handleChange}
								setState={setAddChange}
								state={addChange}
								variant="outlined"
								margin="normal"
								fullWidth
								required
							>
								<MenuItem value="none" disabled selected>
									--Pilih Layanan--
								</MenuItem>
								{stateOption.option1 &&
									stateOption.option1.map((item, i) => (
										<MenuItem key={i} value={item.id}>
											{item.nama}
										</MenuItem>
									))}
								{errors.idlayanan && (
									<Typography variant="caption" color="error">
										{errors.idlayanan.message}
									</Typography>
								)}
							</ReactHookFormSelect>
						</div>

						<div className="card-like-bar">
							<div className="card-text">Title</div>
							<TextField
								autoFocus
								id="title"
								name="title"
								label="Title"
								style={{ minWidth: "200px" }}
								error={errors.title}
								fullWidth
								placeholder="Type your Title"
								type="string"
								variant="outlined"
								inputRef={register({
									required: {
										value: true,
										message: "Title tidak boleh kosong",
									},
								})}
								InputLabelProps={{ shrink: true }}
								helperText={errors.title && errors.title.message}
							/>
						</div>
						<div className="card-like-bar">
							<div className="card-text">Location</div>
							<TextField
								autoFocus
								id="location"
								name="location"
								label="Location"
								style={{ minWidth: "200px" }}
								error={errors.location}
								fullWidth
								placeholder="Type your location"
								type="string"
								variant="outlined"
								inputRef={register({
									required: {
										value: true,
										message: "location tidak boleh kosong",
									},
								})}
								InputLabelProps={{ shrink: true }}
								helperText={errors.location && errors.location.message}
							/>
						</div>
						<div className="card-like-bar">
							<div className="card-text">Description</div>
							<TextField
								autoFocus
								id="deskripsi"
								name="deskripsi"
								label="Description"
								style={{ minWidth: "200px" }}
								error={errors.deskripsi}
								fullWidth
								placeholder="Type your Description"
								type="string"
								multiline
								minRows={2}
								maxRows={10}
								variant="outlined"
								inputRef={register({
									required: {
										value: true,
										message: "Description tidak boleh kosong",
									},
								})}
								InputLabelProps={{ shrink: true }}
								helperText={errors.deskripsi && errors.deskripsi.message}
							/>
						</div>

						<div className="card-like-bar">
							<div className="card-text">Category</div>
							<ReactHookFormSelect
								id="idkategori"
								register={register}
								name="idkategori"
								label="Category"
								control={control}
								error={errors.idkategori}
								value={idkategori}
								style={{ minWidth: "200px" }}
								// handleOption={handleOption}
								// handleChange={handleChange}
								setState={setAddChange}
								state={addChange}
								variant="outlined"
								margin="normal"
								fullWidth
								required
							>
								<MenuItem value="none" disabled selected>
									--Pilih Layanan--
								</MenuItem>
								{stateOption.optionResult &&
									stateOption.optionResult.map((item, i) => (
										<MenuItem key={i} value={item.id}>
											{item.nama}
										</MenuItem>
									))}
							</ReactHookFormSelect>
						</div>

						<div className="card-like-bar">
							<div className="card-text">Files</div>
							<div
								style={{
									border: "2px dashed",
									borderRadius: "10px",
									width: "100%",
									// minHeight: "5vh",
								}}
							>
								<Dropzone
									state={selectFile}
									setState={setSelectFile}
									type="formontask"
								/>
							</div>
						</div>

						<div className="card-like-bar">
							<div className="card-text">Spent Time</div>
							<TextField
								id="deadline"
								name="deadline"
								label="Per Minutes"
								error={errors.deadline}
								className={classes.textField}
								placeholder="Type your Minutes"
								type="number"
								variant="outlined"
								value={stateOption.optionSLA}
								disabled
								inputRef={register({
									required: {
										value: true,
										message: "Spent Time tidak boleh kosong",
									},
								})}
								InputLabelProps={{ shrink: true }}
								helperText={errors.deadline && errors.deadline.message}
							/>
						</div>

						<div className="card-like-bar">
							<div className="card-text">Assignee</div>
							<ButtonGroup disableElevation variant="contained" color="primary">
								<Button
									color={state === 1 ? "secondary" : "default"}
									onClick={() => handleResetGroup("idgroup")}
								>
									Groups
								</Button>
								<Button
									color={state === 2 ? "secondary" : "default"}
									onClick={() => handleResetGroup("iduser")}
								>
									Users
								</Button>
							</ButtonGroup>
						</div>

						{state === 1 ? (
							<div className="card-like-bar">
								<div className="card-text">Groups</div>
								<ReactHookFormSelect
									id="idgroup"
									register={register}
									name="idgroup"
									label="Groups"
									control={control}
									error={errors.idgroup}
									value={idgroup}
									style={{ minWidth: "200px" }}
									// handleOption={handleOption}
									// handleChange={handleChange}
									setState={setAddChange}
									state={addChange}
									variant="outlined"
									margin="normal"
									fullWidth
									required
								>
									<MenuItem value="none" disabled selected>
										--Pilih Groups--
									</MenuItem>
									{stateOption.optionGroupIssue &&
										stateOption.optionGroupIssue.map((item, i) => (
											<MenuItem key={i} value={item.id}>
												{item.nama}
											</MenuItem>
										))}
								</ReactHookFormSelect>
							</div>
						) : state === 2 ? (
							<div className="card-like-bar">
								<div className="card-text">Users</div>
								<ReactHookFormSelect
									id="iduser"
									register={register}
									name="iduser"
									label="ID USERS"
									control={control}
									error={errors.iduser}
									style={{ minWidth: "200px" }}
									value={iduser}
									// handleOption={handleOption}
									// handleChange={handleChange}
									setState={setAddChange}
									state={addChange}
									variant="outlined"
									margin="normal"
									fullWidth
									required
								>
									<MenuItem value="none" disabled selected>
										--Pilih Users--
									</MenuItem>
									{stateOption.optionUserIssue &&
										stateOption.optionUserIssue.map((item, i) => (
											<MenuItem key={i} value={item.id}>
												{item.nama}
											</MenuItem>
										))}
								</ReactHookFormSelect>
							</div>
						) : (
							""
						)}
						<DialogActions
							style={{
								display: "flex",
								marginTop: "2rem",
							}}
						>
							<Button
								type="submit"
								color="primary"
								variant="contained"
								disabled={isLoading}
							>
								Add
							</Button>
							<Button
								variant="contained"
								onClick={() => {
									setState(0);
									handleClose();
									reset();
								}}
							>
								Cancel
							</Button>
						</DialogActions>
					</Card>
				</form>
			</Dialog>
		</div>
	);
}
